import React from 'react'
import {
  ArchiveOutlined,
  ImageOutlined,
  FolderOutlined,
} from '@material-ui/icons'
import styled from 'styled-components'
import { colors } from '../../styles'

export enum FileTreeTypes {
  archive = 'archive',
  image = 'image',
  folder = 'folder',
}

const iconConfig = {
  archive: <ArchiveOutlined />,
  image: <ImageOutlined />,
  folder: <FolderOutlined />,
}

const Style = styled.div`
  display: flex;
  svg {
    color: ${colors.green}; // How to sync with actual theme
    font-size: 16px;
    margin-right: 6px;
  }
` as React.ComponentType<any>

export const FileTreeIcon = ({ mediaType }: { mediaType: FileTreeTypes }) => (
  <Style>{iconConfig[mediaType]}</Style>
)
